import { useEffect } from 'react';
import { Navbar } from './components/Navbar';
import { Hero } from './components/Hero';
import { OfferCard } from './components/OfferCard';
import { ServiceCard } from './components/ServiceCard';
import { Workflow } from './components/WorkFlow';
import { Footer } from './components/Footer';
import { TECH_STACK } from './data/content';
import { initCal } from './utils/booking';

function App() {
  useEffect(() => {
    initCal(); // Initialize the widget once when the app loads
  }, []);
  return (
    <div className="min-h-screen bg-[#0A192F] text-slate-300 font-sans">
      <Navbar />
      
      <main>
        <Hero />
        

        <Workflow/>

        <section id="services" className="py-24 px-6 bg-[#0B1E3B]/50">
          <div className="max-w-7xl mx-auto">
            <h2 className="text-3xl font-bold text-white mb-12 text-center md:text-left tracking-tight">How we support you:</h2>
            <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
              {TECH_STACK.map(service => (
                <ServiceCard key={service.id} {...service} />
              ))}
            </div>
          </div>
        </section>
      </main>
      <OfferCard />
      <Footer />
    </div>
  );
}

export default App;